/* ============================================================
   fh-product-card.js — Universelt produktkort Fiskehandleren
   Selvinneholdt IIFE, ingen imports, ES5-kompatibel
   ============================================================ */
(function () {
  'use strict';

  // --- Beskytt mot dobbel-init ---
  if (window.__fhpCardBound) return;
  window.__fhpCardBound = true;

  /* ----------------------------------------------------------
     HJELPEFUNKSJONER
  ---------------------------------------------------------- */

  /**
   * Hent netto kg fra variant-tittel ("2,5 kg", "300g", "1 stk (150g)",
   * "8 stk (1.2 kg)", "160-180g / 2.5 kg" -> pakke-kg vinner). 0 hvis ukjent.
   */
  function kgFromTitle(title) {
    if (!title) return 0;
    var t = String(title).toLowerCase();
    var kg = t.match(/(\d+(?:[.,]\d+)?)\s*kg/g);
    if (kg && kg.length) { var m = kg[kg.length - 1].match(/(\d+(?:[.,]\d+)?)/); return parseFloat(m[1].replace(',', '.')); }
    var rg = t.match(/(\d+)\s*-\s*(\d+)\s*g\b/);
    if (rg) { return ((parseInt(rg[1], 10) + parseInt(rg[2], 10)) / 2) / 1000; }
    var g = t.match(/(\d+(?:[.,]\d+)?)\s*g\b/g);
    if (g && g.length) { var m2 = g[g.length - 1].match(/(\d+(?:[.,]\d+)?)/); return parseFloat(m2[1].replace(',', '.')) / 1000; }
    return 0;
  }

  /**
   * Formater en kilopris. Netto kg leses fra variant-tittel (kilde for kunden),
   * faller tilbake til variant.weight (gram) hvis tittel mangler vekt (f.eks. "1 stk").
   * @param {number} priceOre  Pris i øre (Shopify-format)
   * @param {number} grams     Vekt i gram fra variant.weight (fallback)
   * @param {string} title     Variant-tittel (primær vektkilde)
   * @returns {string}         "X kr/kg" eller ''
   */
  function formatUnitPrice(priceOre, grams, title) {
    var kg = kgFromTitle(title);
    if (!kg && grams && grams > 0) kg = grams / 1000;
    if (!kg || kg <= 0) return '';
    var perKg = Math.round((priceOre / 100) / kg);
    return 'kr ' + perKg.toLocaleString('nb-NO') + '/kg';
  }

  /**
   * Fyll kilopris paa kort som enda ikke har det (f.eks. lazy-lastet/AJAX-injisert
   * etter at initCards() kjorte). Rorer KUN tomme unit-elementer -> idempotent, ingen loop.
   */
  function fillMissingUnitPrices(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-fhp-unit]').forEach(function (unitEl) {
      if (unitEl.textContent.trim()) return; // allerede satt
      var card = unitEl.closest('[data-fhp-card]') || unitEl.parentNode;
      var sel = card && card.querySelector ? card.querySelector('[data-fhp-chip].is-selected') : null;
      var src = sel || unitEl;
      var price = parseInt(src.getAttribute('data-price'), 10) || 0;
      var grams = parseInt(src.getAttribute('data-grams'), 10) || 0;
      var vtitle = src.getAttribute('data-vtitle') || '';
      var txt = formatUnitPrice(price, grams, vtitle);
      if (txt) unitEl.textContent = txt;
    });
  }

  /**
   * Hent eller opprett toast-element.
   */
  function getToast() {
    var toast = document.querySelector('.fhp-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'fhp-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    return toast;
  }

  /**
   * Vis toast med tekst, skjul etter 2,5 sek.
   * @param {string} msg
   */
  function showToast(msg) {
    var toast = getToast();
    toast.textContent = msg;
    toast.classList.add('is-show');
    clearTimeout(toast.__fhpTimer);
    toast.__fhpTimer = setTimeout(function () {
      toast.classList.remove('is-show');
    }, 2500);
  }

  /**
   * Oppdater alle kjente handlekurv-telle-elementer i headeren.
   * @param {number} count  Totalt antall varer
   */
  function updateCartCount(count) {
    if (count === undefined || count === null || isNaN(count)) return;
    count = parseInt(count, 10);

    var selectors = [
      '[data-cart-count]',
      '.cart-link__bubble',
      '.cart-count-bubble',
      '.header-cart-count',
      '.navlink-cart-count',
      '.cart__count',
      '[data-header-cart-count]'
    ];
    selectors.forEach(function (sel) {
      var els = document.querySelectorAll(sel);
      els.forEach(function (el) {
        var prev = parseInt(el.textContent, 10);
        el.textContent = count;
        if (el.hasAttribute('data-cart-count')) {
          el.setAttribute('data-cart-count', count);
        }
        el.style.display = count > 0 ? '' : 'none';
        if (prev !== count) {
          el.classList.remove('fhp-cart-bump');
          void el.offsetWidth;
          el.classList.add('fhp-cart-bump');
          setTimeout(function () { el.classList.remove('fhp-cart-bump'); }, 500);
        }
      });
    });
  }

  /* ----------------------------------------------------------
     KORTLOGIKK
  ---------------------------------------------------------- */

  /**
   * Oppdater pris, kilopris og variant-ID på et kort basert på en valgt chip.
   * @param {Element} card  [data-fhp-card]
   * @param {Element} chip  [data-fhp-chip]
   */
  function updateCardFromChip(card, chip) {
    var price       = parseInt(chip.getAttribute('data-price'), 10) || 0;
    var compare     = parseInt(chip.getAttribute('data-compare-price'), 10) || 0;
    var grams       = parseInt(chip.getAttribute('data-grams'), 10) || 0;
    var vtitle      = chip.getAttribute('data-vtitle') || '';
    var variantId   = chip.getAttribute('data-variant-id');

    // Pris
    var priceEl = card.querySelector('[data-fhp-price]');
    if (priceEl) priceEl.textContent = chip.getAttribute('data-price-html') || formatMoney(price);

    // Sammenlignspris + SPAR
    var compareEl = card.querySelector('[data-fhp-compare]');
    var sparEl    = card.querySelector('[data-fhp-spar]');

    var sparBadge = card.querySelector('[data-fhp-spar-badge]');

    if (compare && compare > price) {
      var savings = compare - price;
      if (compareEl) {
        compareEl.textContent = formatMoney(compare);
        compareEl.style.display = '';
      }
      if (sparEl) {
        sparEl.textContent = 'SPAR ' + formatMoney(savings);
        sparEl.style.display = '';
      }
      if (sparBadge) {
        sparBadge.textContent = 'SPAR ' + formatMoney(savings);
        sparBadge.style.display = '';
      }
    } else {
      if (compareEl) compareEl.style.display = 'none';
      if (sparEl)    sparEl.style.display    = 'none';
      if (sparBadge) sparBadge.style.display = 'none';
    }

    // Kilopris
    var unitEl = card.querySelector('[data-fhp-unit]');
    if (unitEl) {
      unitEl.setAttribute('data-price', price);
      unitEl.setAttribute('data-grams', grams);
      unitEl.setAttribute('data-vtitle', vtitle);
      unitEl.textContent = formatUnitPrice(price, grams, vtitle);
    }

    // Variant-ID på legg-i-kurv-knappen
    var addBtn = card.querySelector('[data-fhp-add]');
    if (addBtn && variantId) {
      addBtn.setAttribute('data-variant-id', variantId);
    }

    // FH 2026-09-07: betal ved levering har ingen hurtigkjøp, men en Bestill-lenke til
    // produktsiden. Uten denne oppdateringen ville kunden se prisen for «3-5 kg» på
    // kortet og lande på produktsiden med standardvarianten «1-3 kg» valgt. På en
    // bindende bestilling er det et prisløfte vi bryter i selve overgangen.
    var bvlLink = card.querySelector('[data-fhp-bvl-link]');
    if (bvlLink && variantId) {
      var baseUrl = bvlLink.getAttribute('data-product-url') || '';
      if (baseUrl) bvlLink.setAttribute('href', baseUrl + '?variant=' + variantId);
    }
  }

  /**
   * Initialiser alle kort på siden:
   * - Sett kilopris fra valgt chip eller enkeltvariant
   * - Sorter chips
   * - Rens chip-tekst
   * - Rens titler
   */
  function initCards() {
    sortChips();
    cleanChipText();
    fixMultiOptionChips();
    stripKgFromTitles();

    var cards = document.querySelectorAll('[data-fhp-card]');
    cards.forEach(function (card) {
      // Sett kilopris fra den allerede valgte chipen (is-selected)
      var selectedChip = card.querySelector('[data-fhp-chip].is-selected');
      if (selectedChip) {
        var price = parseInt(selectedChip.getAttribute('data-price'), 10) || 0;
        var grams = parseInt(selectedChip.getAttribute('data-grams'), 10) || 0;
        var vtitle = selectedChip.getAttribute('data-vtitle') || '';
        var unitEl = card.querySelector('[data-fhp-unit]');
        if (unitEl) unitEl.textContent = formatUnitPrice(price, grams, vtitle);
        return;
      }
      // Enkeltvariant: sett kilopris fra data-attributter på unit-elementet
      var unitEl = card.querySelector('[data-fhp-unit]');
      if (unitEl) {
        var p = parseInt(unitEl.getAttribute('data-price'), 10) || 0;
        var g = parseInt(unitEl.getAttribute('data-grams'), 10) || 0;
        var vt = unitEl.getAttribute('data-vtitle') || '';
        unitEl.textContent = formatUnitPrice(p, g, vt);
      }
    });
  }

  /**
   * Fjern "X g / " eller "X g/ " prefikser fra chip-tekst.
   * Behold kun vektdelen (f.eks. "5 kg").
   */
  function cleanChipText() {
    var chips = document.querySelectorAll('[data-fhp-chip]');
    chips.forEach(function (chip) {
      var txt = chip.textContent.trim();
      if (txt.indexOf(' / ') !== -1) {
        var parts = txt.split(' / ');
        chip.textContent = parts[parts.length - 1].trim();
      }
    });
  }

  /**
   * Fiks chips for multi-option produkter (f.eks. Kongekrabbe med vekt + størrelse).
   * Sjekker om et chip-container har duplikat-tekst, henter produktdata, og setter full label.
   */
  function fixMultiOptionChips() {
    var containers = document.querySelectorAll('.fh-pi-chips, [data-fhp-chips], [data-fh-pi-chips]');
    containers.forEach(function (container) {
      if (container.dataset.fhChipsFixed) return;
      var chips = Array.prototype.slice.call(container.querySelectorAll('.fh-pi-chip, [data-fhp-chip]'));
      if (chips.length < 3) return;
      var texts = chips.map(function (c) { return c.textContent.trim(); });
      var unique = texts.filter(function (t, i) { return texts.indexOf(t) === i; });
      if (unique.length >= texts.length) return;
      container.dataset.fhChipsFixed = '1';
      var item = container.closest('.product-item, [data-fhp-card]');
      if (!item) return;
      var link = item.querySelector('a[href*="/products/"]');
      if (!link) return;
      var href = link.getAttribute('href').split('?')[0];
      fetch(href + '.js').then(function (r) { return r.json(); }).then(function (prod) {
        if (!prod || !prod.variants) return;
        var hasMultiOpt = prod.options && prod.options.length > 1;
        if (!hasMultiOpt) return;
        chips.forEach(function (chip) {
          var vid = chip.getAttribute('data-variant-id');
          if (!vid) return;
          var vidNum = parseInt(vid, 10);
          for (var i = 0; i < prod.variants.length; i++) {
            if (prod.variants[i].id === vidNum) {
              chip.textContent = prod.variants[i].title;
              break;
            }
          }
        });
      }).catch(function () {});
    });
  }

  /**
   * Sorter chips innen hvert chip-container etter pris stigende.
   */
  function sortChips() {
    var containers = document.querySelectorAll('[data-fhp-chips]');
    containers.forEach(function (container) {
      var chips = Array.prototype.slice.call(container.querySelectorAll('[data-fhp-chip]'));
      if (chips.length < 2) return;
      chips.sort(function (a, b) {
        var pa = parseInt(a.getAttribute('data-price'), 10) || 0;
        var pb = parseInt(b.getAttribute('data-price'), 10) || 0;
        return pa - pb;
      });
      chips.forEach(function (c) { container.appendChild(c); });
    });
  }

  /**
   * Fjern " X kg" eller "(X kg)" fra slutten av .fhp__name-tekster.
   */
  function stripKgFromTitles() {
    var names = document.querySelectorAll('.fhp__name');
    names.forEach(function (el) {
      var txt = el.textContent.trim();
      // Fjern avsluttende "(X kg)" eller " X kg"
      txt = txt.replace(/\s*\(\d+[\.,]?\d*\s*kg\)\s*$/i, '').trim();
      txt = txt.replace(/\s+\d+[\.,]?\d*\s*kg\s*$/i, '').trim();
      el.textContent = txt;
    });
  }

  /* ----------------------------------------------------------
     FORMATERING
  ---------------------------------------------------------- */

  /**
   * Formater øre til norsk pengeverdi, f.eks. "1 990,00 kr".
   * @param {number} ore
   * @returns {string}
   */
  function formatMoney(ore) {
    var kr = (ore / 100).toFixed(2);
    var parts = kr.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' '); // narrow no-break space
    return parts.join(',') + ' kr'; // non-breaking space before kr
  }

  /* ----------------------------------------------------------
     EVENT-DELEGATION
  ---------------------------------------------------------- */

  document.addEventListener('click', function (e) {

    /* --------------------------------------------------------
       CHIP-KLIKK
    -------------------------------------------------------- */
    var chip = e.target.closest('[data-fhp-chip]');
    if (chip) {
      var chipCard = chip.closest('[data-fhp-card]');
      if (!chipCard) return;

      // Ikke gjør noe om chipen allerede er valgt eller utilgjengelig
      if (chip.classList.contains('is-selected')) return;
      if (chip.classList.contains('is-unavailable')) return;

      // Oppdater valgt-tilstand
      var allChips = chipCard.querySelectorAll('[data-fhp-chip]');
      allChips.forEach(function (c) { c.classList.remove('is-selected'); });
      chip.classList.add('is-selected');

      // Oppdater pris og variant
      updateCardFromChip(chipCard, chip);
      return;
    }

    /* --------------------------------------------------------
       LEGG I KURV
    -------------------------------------------------------- */
    var addBtn = e.target.closest('[data-fhp-add]');
    if (addBtn) {
      var variantId = addBtn.getAttribute('data-variant-id');
      var productTitle = addBtn.getAttribute('data-product-title') || 'Varen';
      if (!variantId || addBtn.classList.contains('is-loading')) return;

      addBtn.classList.add('is-loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Feil ved legg i kurv'); });
          return r.json();
        })
        .then(function () {
          // Hent oppdatert handlekurv
          return fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } });
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          addBtn.classList.remove('is-loading');
          addBtn.classList.add('is-success');

          var cardEl = addBtn.closest('[data-fhp-card]');
          if (cardEl) flyToCart(cardEl, addBtn);

          updateCartCount(cart.item_count);
          showToast(decodeHtmlEntities(productTitle) + ' lagt i kurven');

          setTimeout(function () {
            addBtn.classList.remove('is-success');
          }, 2000);
        })
        .catch(function (err) {
          addBtn.classList.remove('is-loading');
          showToast(err.message || 'Noe gikk galt. Prøv igjen.');
        });
      return;
    }

    /* --------------------------------------------------------
       ANTALL MINUS (cart context)
    -------------------------------------------------------- */
    var minusBtn = e.target.closest('[data-fhp-qty-minus]');
    if (minusBtn) {
      var itemKey = minusBtn.getAttribute('data-item');
      var qtyEl = minusBtn.closest('.fhp__cart-qty');
      var numEl = qtyEl ? qtyEl.querySelector('[data-fhp-qty-num]') : null;
      var current = numEl ? parseInt(numEl.textContent, 10) : 1;
      if (current <= 1) {
        // Fjern linjen
        changeCartLine(itemKey, 0, numEl, minusBtn);
      } else {
        changeCartLine(itemKey, current - 1, numEl, minusBtn);
      }
      return;
    }

    /* --------------------------------------------------------
       ANTALL PLUSS (cart context)
    -------------------------------------------------------- */
    var plusBtn = e.target.closest('[data-fhp-qty-plus]');
    if (plusBtn) {
      var itemKey2 = plusBtn.getAttribute('data-item');
      var qtyEl2 = plusBtn.closest('.fhp__cart-qty');
      var numEl2 = qtyEl2 ? qtyEl2.querySelector('[data-fhp-qty-num]') : null;
      var current2 = numEl2 ? parseInt(numEl2.textContent, 10) : 1;
      changeCartLine(itemKey2, current2 + 1, numEl2, plusBtn);
      return;
    }

    /* --------------------------------------------------------
       VARIANT-SWAP (cart context — bytt variant i kurven)
    -------------------------------------------------------- */
    var swapBtn = e.target.closest('[data-fhp-swap]');
    if (swapBtn) {
      if (swapBtn.classList.contains('is-selected')) return;
      var newVariant = swapBtn.getAttribute('data-new-variant');
      var oldVariant = swapBtn.getAttribute('data-old-variant');
      var lineKey = swapBtn.getAttribute('data-line-key');
      var swapQty = parseInt(swapBtn.getAttribute('data-qty'), 10) || 1;
      if (!newVariant || !lineKey) return;

      swapBtn.style.opacity = '0.5';

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: 0 })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Feil'); });
          return r.json();
        })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(newVariant, 10), quantity: swapQty }] })
          });
        })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Feil'); });
          return r.json();
        })
        .then(function () {
          window.location.reload();
        })
        .catch(function (err) {
          swapBtn.style.opacity = '1';
          showToast(err.message || 'Kunne ikke bytte variant.');
        });
      return;
    }

    /* --------------------------------------------------------
       FJERN LINJEELEMENT (cart context)
    -------------------------------------------------------- */
    var removeBtn = e.target.closest('[data-fhp-remove]');
    if (removeBtn) {
      var itemKey3 = removeBtn.getAttribute('data-item');
      changeCartLine(itemKey3, 0, null, removeBtn);
      return;
    }

  }); // end document click

  /* ----------------------------------------------------------
     HANDLEKURV-ENDRING (antall/fjern)
  ---------------------------------------------------------- */

  /**
   * Endre antall for en linje i handlekurven.
   * @param {string}       lineKey   cart line item key
   * @param {number}       qty       ønsket antall (0 = fjern)
   * @param {Element|null} numEl     element som viser antallet ([data-fhp-qty-num])
   * @param {Element}      triggerEl knappen som ble trykket (for loading-state)
   */
  function changeCartLine(lineKey, qty, numEl, triggerEl) {
    if (triggerEl) triggerEl.classList.add('is-loading');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: qty })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Feil'); });
        return r.json();
      })
      .then(function (cart) {
        if (triggerEl) triggerEl.classList.remove('is-loading');

        updateCartCount(cart.item_count);

        if (qty === 0) {
          // Fjern kort fra DOM
          var cardEl = triggerEl ? triggerEl.closest('[data-fhp-cart-item]') : null;
          if (cardEl) {
            cardEl.style.transition = 'opacity 0.25s, max-height 0.3s';
            cardEl.style.opacity = '0';
            cardEl.style.overflow = 'hidden';
            cardEl.style.maxHeight = cardEl.offsetHeight + 'px';
            setTimeout(function () {
              cardEl.style.maxHeight = '0';
              cardEl.style.padding = '0';
              cardEl.style.margin = '0';
              cardEl.style.borderBottom = 'none';
              setTimeout(function () { cardEl.remove(); }, 310);
            }, 20);
          }
        } else {
          // Oppdater antall-visning
          if (numEl) numEl.textContent = qty;
        }
      })
      .catch(function (err) {
        if (triggerEl) triggerEl.classList.remove('is-loading');
        showToast(err.message || 'Noe gikk galt.');
      });
  }

  /* ----------------------------------------------------------
     HJELPEFUNKSJON: dekod HTML-entiteter
  ---------------------------------------------------------- */
  /* ----------------------------------------------------------
     FLY-TO-CART ANIMASJON
  ---------------------------------------------------------- */

  // FIX 2026-09-11: finn det SYNLIGE kurv-ikonet oeverst (header). Gammel selector traff
  // ikke det ekte ikonet (navlink--cart / data-cart-toggle) -> traff skjult 0-rect element
  // -> animasjonen floey til (0,0) = venstre hjoerne. Naa: oeverste synlige kurv-ikon.
  function findVisibleCartIcon() {
    var cands = document.querySelectorAll('[data-cart-toggle], .navlink--cart, .cart-link, [data-cart-count], a[href="/cart"]');
    var best = null, bestTop = Infinity;
    for (var i = 0; i < cands.length; i++) {
      var r = cands[i].getBoundingClientRect();
      if (r.width > 0 && r.height > 0 && r.top < bestTop) { best = cands[i]; bestTop = r.top; }
    }
    return best;
  }

  // Fly-til-kurv (Viktors retning 2026-09-11): FORUTSIGBAR animasjon uavhengig av hvor
  // knappen er / scroll. Produktbildet zoomer inn i MIDTEN av skjermen, holder et oyeblikk,
  // og flyr saa opp til kurv-ikonet oeverst til hoyre mens det krymper og fader.
  function flyImageToCart(imgOrSrc) {
    // Godtar enten et <img>-element eller en URL-streng (produktside sender featured-URL).
    var src = (typeof imgOrSrc === 'string') ? imgOrSrc : (imgOrSrc && (imgOrSrc.currentSrc || imgOrSrc.src));
    if (!src) return;
    var cartIcon = findVisibleCartIcon();
    if (!cartIcon) return;
    var cartRect = cartIcon.getBoundingClientRect();
    if (!cartRect.width) return;

    var vw = window.innerWidth, vh = window.innerHeight;
    var size = Math.max(96, Math.min(150, Math.round(Math.min(vw, vh) * 0.34)));
    var centerX = Math.round(vw / 2 - size / 2);
    var centerY = Math.round(vh / 2 - size / 2);

    var clone = document.createElement('div');
    clone.style.cssText =
      'position:fixed;z-index:100000;pointer-events:none;overflow:hidden;border-radius:16px;' +
      'top:' + centerY + 'px;left:' + centerX + 'px;width:' + size + 'px;height:' + size + 'px;' +
      'background-image:url(' + src + ');background-size:cover;background-position:center;' +
      'box-shadow:0 14px 44px rgba(0,0,0,.30);opacity:0;transform:scale(.55);' +
      'transition:opacity .2s ease, transform .2s cubic-bezier(.2,.9,.3,1);';
    document.body.appendChild(clone);
    void clone.offsetWidth; // commit startstate foer transition

    // Fase 1: zoom inn i midten
    clone.style.opacity = '1';
    clone.style.transform = 'scale(1)';

    // Fase 2: fly opp til kurv-ikonet oeverst til hoyre
    setTimeout(function () {
      var dx = (cartRect.left + cartRect.width / 2) - (centerX + size / 2);
      var dy = (cartRect.top + cartRect.height / 2) - (centerY + size / 2);
      clone.style.transition = 'transform .6s cubic-bezier(.55,0,.8,.45), opacity .6s ease .12s';
      clone.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(.16)';
      clone.style.opacity = '0';
    }, 260);

    setTimeout(function () { clone.remove(); }, 950);
  }

  function flyToCart(cardEl) { flyImageToCart(cardEl.querySelector('.fhp__img')); }
  window.fhFlyToCart = flyImageToCart; // gjenbrukbar (produktside m.m.)


  /* ----------------------------------------------------------
     IMAGE LOAD OBSERVER (shimmer fade-in)
  ---------------------------------------------------------- */

  function observeImages() {
    var grid = document.querySelector('[data-fhp-grid], .collection-products, .product-grid');
    if (grid && !grid.classList.contains('fhp--shimmer')) {
      grid.classList.add('fhp--shimmer');
    }

    var imgs = document.querySelectorAll('.fhp__media .fhp__img');
    var pending = 0;
    imgs.forEach(function (img) {
      if (img.complete && img.naturalWidth > 0) {
        img.classList.add('is-loaded');
      } else {
        pending++;
        function done() {
          img.classList.add('is-loaded');
          pending--;
          if (pending <= 0 && grid) grid.classList.remove('fhp--shimmer');
        }
        img.addEventListener('load', done, { once: true });
        img.addEventListener('error', done, { once: true });
      }
    });
    if (pending === 0 && grid) grid.classList.remove('fhp--shimmer');
  }


  var _decodeEl;
  function decodeHtmlEntities(str) {
    try {
      if (!_decodeEl) _decodeEl = document.createElement('textarea');
      _decodeEl.innerHTML = str;
      return _decodeEl.value;
    } catch (ex) {
      return str;
    }
  }

  /* ----------------------------------------------------------
     INIT
  ---------------------------------------------------------- */

  function initAll() {
    initCards();
    fixMultiOptionChips();
    fillMissingUnitPrices();
    observeImages();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('cart:updated', function () {
    setTimeout(initAll, 100);
  });

  var _reinitTimer = null;
  var _labelObserver = new MutationObserver(function () {
    fixMultiOptionChips();
    // Lazy-lastede/AJAX-injiserte kort faar kilopris (debounced, idempotent)
    clearTimeout(_reinitTimer);
    _reinitTimer = setTimeout(fillMissingUnitPrices, 120);
  });
  _labelObserver.observe(document.body, { childList: true, subtree: true });

  // Eksporter init for manuell kall fra andre skript
  window.fhpInitCards = initCards;

})();
